<template>
  <v-app
    style="background: #ebebeb"
  >
  <v-container
    class="fill-height"
  >
    <v-row>
      <v-col cols="3" align="left">
         <ps-button
              id="ProfitSwordLinkButton"
              class="loginFormLink"
              href="https://profitsword.com"
              target="_blank"
              text
              depressed
              color="#777"
            >
              {{ this.translate('label.poweredByProfitSword') }}
            </ps-button>
      </v-col>
      <v-col cols="6"></v-col>
      <v-col cols="3" align="right">
       <div class="socialIcons" style="float:right">
              <a
                target="_blank"
                href="https://www.facebook.com/profitsword/"
              ><img :src="FbLogo"></a>
              <a
                target="_blank"
                href="https://twitter.com/profitsword"
              ><img :src="TwitterLogo"></a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/profitsword/"
              ><img :src="InLogo"></a>
              <a
                target="_blank"
                href="https://www.instagram.com/profitsword/"
              ><img :src="IgLogo"></a>
            </div>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      align="center"
      no-gutters
    >
      <v-col
        cols="7"
        justify="center"
        align="center"
        class="d-flex elevation-5 flex-row justify-center mb-6 login-card"
        style="background:white; max-width: 680px; min-width: 680px;"
      >
        
         <v-card
          class="d-flex align-content-center flex-wrap"
          min-width="18em"
          style="box-shadow:none; margin:40px 0 20px 20px;"
        >
        <div class="loginLogo">
          <img
              id="clientLogo"
              :src="logo"
              width = "80%"      
            />
        </div>
          
          <v-row>
            <v-col 
              class="white--text clientName"
            >
              {{ psClientName }}
            </v-col>
          </v-row>
        </v-card>
        <v-card
          v-if="!showLanding"
          class=" align-content-center"
          min-width="18em"
          tile
          style="box-shadow:none; margin:40px 0 20px 20px; border-left:1px solid #d7d7d7"
        >
         
            <v-card-text
              class="headline"
            >
              {{ this.translate("message.UNAUTHORIZED") }}
            </v-card-text>
          
           
          </v-card-text>
        </v-card>
      
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
      <v-row>
      <v-col cols="3" align="left">
        <a href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071">Latest Release Notes</a>
      </v-col>
      <v-col cols="6"></v-col>
      <v-col cols="3" align="right" style="float:right">
         <p
              v-if="version"
              class="version"
            >
              {{ this.translate("label.version") + " " + version }}
            </p>
      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>



<script>
import canvas_bg from  "../assets/canvas_bg.png";
import PsLogo from "../assets/logo.png";

const bodyHeight = document.getElementById("NavBar") != null ?
    window.innerHeight - document.getElementById("NavBar").offsetHeight : window.innerHeight;

export default {
    
    data() {
        return {
            name: "Unauthorized", 
            psClientName: "PS-Authenticate",           
            logo: PsLogo,            
            background: canvas_bg
        };
    }, 
    mounted() {
        localStorage.clear();
        sessionStorage.clear();
    },
};
</script>
